import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import useToast from "../useToast";

/**
 * Hook to recalculate league member scores for all leagues
 * This forces a full recalculation of all scores across all leagues
 */
export const useRecalculateLeagueMemberScores = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  const toast = useToast();
  const apiUrl = process.env.REACT_APP_API_URL;

  return useMutation(
    async () => {
      const token = await getAccessTokenSilently();
      const response = await axios.post(
        `${apiUrl}/api/league/update-league-member-scores`,
        {
          recalculate: true,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    },
    {
      onSuccess: (data) => {
        const message =
          data.message || "League member scores recalculated successfully!";
        toast.success(message);
        queryClient.invalidateQueries("leagueDetails");
        queryClient.invalidateQueries("leagueMembers");
        queryClient.invalidateQueries("userLeagues");
      },
      onError: (error) => {
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred recalculating league member scores.";
        toast.error(errorMessage);
      },
    },
  );
};
